import { render } from "./taskItem.vue?vue&type=template&id=f5743488&scoped=true"
import script from "./taskItem.vue?vue&type=script&lang=js"
export * from "./taskItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "../less/commentsHub.less?vue&type=style&index=0&module=true&lang=less&external"
cssModules["$style"] = style0
import "./taskItem.vue?vue&type=style&index=1&id=f5743488&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-f5743488"]])

export default __exports__